import { ReactNode } from 'react';
import { Sheet, SheetContent, SheetTitle, SheetDescription } from '@/components/ui/sheet';

interface FormDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  children: ReactNode;
  width?: string;
}

export function FormDrawer({ isOpen, onClose, title, description, children, width = "max-w-4xl" }: FormDrawerProps) {
  if (!isOpen) return null;

  const isCustomWidth = width.includes("(") || width.includes("px") || width.includes("rem");
  const maxWidthClass = isCustomWidth ? "!max-w-none" : width.startsWith("max-w-") ? `!${width}` : "!max-w-4xl";

  return (
    <Sheet open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <SheetContent
        side="right"
        showClose={false}
        className={`p-0 bg-white shadow-2xl overflow-hidden h-screen-safe flex flex-col w-full ${maxWidthClass}`}
        style={{
          width: isCustomWidth ? width : undefined,
        }}
      >
        <SheetTitle className="sr-only">{title}</SheetTitle>
        {description && <SheetDescription className="sr-only">{description}</SheetDescription>}

        <div className="flex justify-between items-start p-8 border-b shrink-0">
          <div className="flex-1 pr-4 min-w-0">
            <h3 className="text-2xl font-bold text-gray-900 leading-tight">
              {title}
            </h3>
            {description && <p className="text-sm text-gray-600 mt-2 leading-relaxed">{description}</p>}
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-3xl font-bold flex-shrink-0"
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div className="flex-1 overflow-y-auto overscroll-contain [-webkit-overflow-scrolling:touch] p-8 pb-[calc(2rem+env(safe-area-inset-bottom))] brand-scroll">
          <div className="space-y-6 pr-2">{children}</div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
